import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class PimAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVbr = 25;
		this.normIrated = 20;
		this.normVceSat = 0.5;
		this.normRdsOnTyp = 40;
		this.normVfTyp = 0.4;

		this.rankVbr = 0;
		this.rankIrated = 0;
		this.rankVceSat = 0;
		this.rankRdsOnTyp = 0;
		this.rankVfTyp = 0;

		this.weightVbr = 0.2;
		this.weightIrated = 0.05;
		this.weightVceSat = 0.1;
		this.weightRdsOnTyp = 0.1;
		this.weightVfTyp = 0.05;

		this.rVbr = 0;
		this.rIrated = 0;
		this.rVceSat = 0;
		this.rRdsOnTyp = 0;
		this.rVfTyp = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,part_Vbr,rVbr,rankVbr,part_Irated,rIrated,rankIrated,part_VceSat,rVceSat,rankVceSat,' +
					'part_RdsOnTyp,rRdsOnTyp,rankRdsOnTyp,part_VfTyp,rVfTyp,rankVfTyp,feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Breakdown voltage  VBR Max (V)---------------------------------------------

		[this.rankVbr, this.rVbr] = this.calculateRankSingleSliderGTE(CIDS.BREAKDOWN_VOLTAGE_DSS, product, this.normVbr);

		// ---------------------------------------------Rated current  IOut Max (A)---------------------------------------------

		[this.rankIrated, this.rIrated] = this.calculateRankSingleSliderGTE(CIDS.RATED_CURRENT, product, this.normIrated);

		// ---------------------------------------------Saturation voltage  VCE(sat) Typ (V)---------------------------------------------

		[this.rankVceSat, this.rVceSat] = this.calculateRankDualSliderGTE(
			CIDS.SATURATION_VOLTAGE,
			product,
			this.normVceSat
		);

		// ---------------------------------------------On state resistance  RDS(on) Typ (mΩ)---------------------------------------------

		[this.rankRdsOnTyp, this.rRdsOnTyp] = this.calculateRankDualSliderGTE(
			CIDS.ON_STATE_DS_RESISTANCE_TYP,
			product,
			this.normRdsOnTyp
		);

		// ---------------------------------------------Diode forward voltage  VF Typ (V)---------------------------------------------

		[this.rankVfTyp, this.rVfTyp] = this.calculateRankSingleSliderLTE(CIDS.V_F_TYP, product, this.normVfTyp);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightVbr * this.rankVbr +
			this.weightIrated * this.rankIrated +
			this.weightVceSat * this.rankVceSat +
			this.weightRdsOnTyp * this.rankRdsOnTyp +
			this.weightVfTyp * this.rankVfTyp;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank =
			(1 - this.weightVbr - this.weightIrated - this.weightVceSat - this.weightRdsOnTyp - this.weightVfTyp) *
				super.execute(product) +
			feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
